



















































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, Getter, State } from "vuex-class";

import AliasedRequestProgressContainer from "@/components/ui/AliasedRequestProgressContainer.vue";

import { GetMyInvoicesInvoiceListItem } from "@/interfaces/falcon/get-my-invoices/get-my-invoices-invoice-list-item";
import { DoDocumentPrintFalconRequest } from "@/interfaces/falcon/do-document-print/do-document-print-falcon-request";

import { falconDocumentTypeFilter } from "@/filters/falcon/falcon-document-type.filter";
import { falconDocumentsPaymentTypeFilter } from "@/filters/falcon/falcon-documents-payment-type.filter";
import { falconDocumentsPaymentStatusFilter } from "@/filters/falcon/falcon-documents-payment-status.filter";
import { capitalizeFilter } from "@/filters/capitalize.filter";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";
import { FalconDocumentsPaymentStatus } from "@/enums/falcon/documents/falcon-documents-payment-status.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents table component
 */
@Component({
  components: { AliasedRequestProgressContainer },
  filters: {
    ...falconDocumentTypeFilter,
    ...falconDocumentsPaymentTypeFilter,
    ...falconDocumentsPaymentStatusFilter,
    ...capitalizeFilter
  }
})
export default class DocumentsTable extends Vue {
  @Action("falconDocuments/getDocumentPrint")
  private getDocumentPrint!: (request: DoDocumentPrintFalconRequest) => void;

  @Getter("ui/isAnyAliasedRequestPending")
  isAnyAliasedRequestPending!: (alias: string) => void;
  @State(state => state.falconDocuments.documentsData)
  documentsData!: GetMyInvoicesInvoiceListItem[];
  requestAliasEnum = RequestAlias;
  documentPaymentStatusEnum = FalconDocumentsPaymentStatus;
  i18nMessageKeyEnum = I18nMessageKey;

  /**
   * Returns link address
   * @param documentId
   * @private
   */
  private getDocumentDetailsLinkAddress(documentId: string): string {
    return `/app/falcon/documents/${documentId}/details`;
  }

  /**
   * Method which handles table click event.
   * Currently it handles document print action
   * @param event Click MouseEvent data
   * @private
   */
  private tableClicked(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const targetTagName = target.tagName.toLowerCase();
    const targetParentElClassList = target.parentElement?.classList;
    const isModernBrowserDownloadActionRequested =
      targetTagName === "i" &&
      targetParentElClassList?.contains("button--download");
    const isLegacyBrowserDownloadActionRequested =
      targetTagName === "button" &&
      targetParentElClassList?.contains("table__cell") &&
      target.children[0]?.classList.contains("icon--download-print");
    if (
      isModernBrowserDownloadActionRequested ||
      isLegacyBrowserDownloadActionRequested
    ) {
      let documentId: string;
      if (isLegacyBrowserDownloadActionRequested) {
        documentId = (target.children[0] as HTMLElement).dataset
          .documentId as string;
      } else {
        documentId = target.dataset.documentId as string;
      }
      this.getDocumentPrint({
        doDocumentPrint: {
          documentId: documentId
        }
      });
    }
  }
}
